import gql from "graphql-tag";

export const createRoleMutation = gql`
  mutation createRole($name: String!, $type: RoleType!, $permissions: [ID!]!) {
    createRole(name: $name, type: $type, permissions: $permissions) {
      id
    }
  }
`;
